<template>
  <div class="foot mt30">
    <div class="warp clearfix warp-foot">
      <div class="foot-left fl">
        <div class="foot-logo">
          <!-- <img class="fl" src="http://cicg.oss-cn-beijing.aliyuncs.com/logo-w.png"> -->
          <p class="fl">黄海科学技术研究院</p>
        </div>
        <!-- <div class="link-content">
          <div id="title">友情链接</div>
          <div id="items">
            <div id="contents">
              <div v-for="item in links" :key="item.id">
                <a :href="item.url" class="mr-2" target="_blank">{{
                  item.title
                }}</a>
              </div>
            </div>
          </div>
        </div> -->
        <p class="foot-tel">86-0543-2226366</p>
        <p class="foot-about">
          <a href="/article?id=29">关于我们</a>
          <a href="/article?id=30">隐私政策</a>
          <a href="/article?id=31">法律声明</a>
        </p>
        <p class="foot-copyright">
          © 2025-2028 黄海科学技术研究院 版权所有
          <a
            href="http://beian.miit.gov.cn/"
            target="_blank"
            title="黄海科学技术研究院ICP备案查询"
            >&nbsp;鲁ICP备17042368号</a
          >
        </p>
      </div>
      <div class="foot-right fr">
        <!-- <div class="foot-xcx">
                    <img src="http://cicg.oss-cn-beijing.aliyuncs.com/ewm.jpg">
                    <p class="foot-xcx-p">欢迎关注公众号</p>
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ifoot",
  props: {
    msg: String,
  },
  data() {
    return {
      links: [],
    };
  },
  created: function() {
    this.getLinks();
  },
  methods: {
    getLinks() {
      this.$get("/links/get-links-list").then((res) => {
        if (res.code == 0) {
          this.links = res.data;
        } else {
          // console.log(res.message)
        }
      });
    },
  },
};
</script>

<style>
.foot-copyright a {
  color: grey;
}
@media screen and (max-width: 768px) {
  .foot {
    min-width: 100%;
  }
  .foot-left {
    width: 76%;
  }
  .foot-right {
    display: none;
  }
  .foot-logo {
    height: 40px;
    margin-left: 15px;
  }
  #title {
    text-align: left;
  }
  .warp {
    margin-top: 0;
  }
  .contents {
    text-align: left;
  }
}
@media screen and (max-width: 320px) {
  .warp {
    margin-top: 0;
  }
}
</style>
